<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
body{
  background-color: rgb(242, 242, 242);
}
*{ padding: 0;margin: 0; }

a { color: #616161;text-decoration: none; }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.contentwrap{
  display: flex;
  flex-flow: row nowrap;
  /* justify-content: space-between; */
  align-content: stretch;
  align-items: stretch;
  width: 1200px;
  margin: auto;
}
.contentwrap > *:nth-of-type(1){
  width: 15%;
}
.contentwrap > *:nth-of-type(2){
  width: 85%;
  background-color: rgb(242, 242, 242);
}
</style>



// WEBPACK FOOTER //
// src/App.vue